import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulletListIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.5 15.834V14.1673H17.5V15.834H7.5ZM7.5 10.834V9.16732H17.5V10.834H7.5ZM7.5 5.83398V4.16732H17.5V5.83398H7.5ZM4.16667 16.6673C3.70833 16.6673 3.31597 16.5041 2.98958 16.1777C2.66319 15.8513 2.5 15.459 2.5 15.0007C2.5 14.5423 2.66319 14.15 2.98958 13.8236C3.31597 13.4972 3.70833 13.334 4.16667 13.334C4.625 13.334 5.01736 13.4972 5.34375 13.8236C5.67014 14.15 5.83333 14.5423 5.83333 15.0007C5.83333 15.459 5.67014 15.8513 5.34375 16.1777C5.01736 16.5041 4.625 16.6673 4.16667 16.6673ZM4.16667 11.6673C3.70833 11.6673 3.31597 11.5041 2.98958 11.1777C2.66319 10.8513 2.5 10.459 2.5 10.0007C2.5 9.54232 2.66319 9.14996 2.98958 8.82357C3.31597 8.49718 3.70833 8.33398 4.16667 8.33398C4.625 8.33398 5.01736 8.49718 5.34375 8.82357C5.67014 9.14996 5.83333 9.54232 5.83333 10.0007C5.83333 10.459 5.67014 10.8513 5.34375 11.1777C5.01736 11.5041 4.625 11.6673 4.16667 11.6673ZM2.98958 6.17773C2.66319 5.85135 2.5 5.45898 2.5 5.00065C2.5 4.54232 2.66319 4.14996 2.98958 3.82357C3.31597 3.49718 3.70833 3.33398 4.16667 3.33398C4.625 3.33398 5.01736 3.49718 5.34375 3.82357C5.67014 4.14996 5.83333 4.54232 5.83333 5.00065C5.83333 5.45898 5.67014 5.85135 5.34375 6.17773C5.01736 6.50412 4.625 6.66732 4.16667 6.66732C3.70833 6.66732 3.31597 6.50412 2.98958 6.17773Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgBulletListIcon);
export { ForwardRef as ReactComponent };
